import script from "./DealRoomTeamInvite.vue?vue&type=script&setup=true&lang=js"
export * from "./DealRoomTeamInvite.vue?vue&type=script&setup=true&lang=js"

import "./DealRoomTeamInvite.vue?vue&type=style&index=0&id=5e51c8fc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e51c8fc"]])

export default __exports__